import type BaseModuleModel from "../src/modules/core/BaseModuleModel";
import type {
  ModuleModelData,
  Snapshot,
} from "../src/modules/core/BaseModuleModel";
import type { EditorValue } from "../src/ui/YooptaEditor";
import type { PlanTemplateType } from "./generated/template_types";
import type { ModuleDefaultData } from "./generator/types";

export enum PlaniraPlanImage {
  Calendar = "calendar",
  Woodworker = "woodworker",
  Party = "party",
  Travel = "travel",
}

export enum PlanType {
  Planira = "planira",
  Quickstart = "quickstart",
}

export type ModuleCompleteInfo = {
  question: string;
  description: string;
  addModules: PlaniraTemplateModule[];
};

export type PlaniraTemplate = {
  planType: PlanType;
  type: PlanTemplateType;
  title: string;
  titleHelp?: string;
  suggestedTitles?: string[]; // used when creating
  description: string;
  longDescription: string;
  emoji: string;
  imageType?: PlaniraPlanImage;
  image?: string;
  sections: {
    section: {
      title?: string;
      isDraggable?: boolean;
      isExpandable?: boolean;
      attractState?: ModuleState;
    };
    modules: PlaniraTemplateModule[];
  }[];

  onTemplateComplete?: {
    outroTitle: string;
    outroDescription: string;
  };
};

export enum ModuleDoneType {
  None = "none",
  // Onboarding results in either Static or Voting after an inlined Yes / No question
  Onboarding = "onboarding",
  Static = "static",
  Voting = "voting",
}

export enum ModuleType {
  PlanInfo = "plan-info",
  Info = "info",
  Checkboxes = "checkboxes",
  Calendar = "calendar",
  Poll = "poll",
  DateDue = "date_due",
  Reminder = "reminder",
  Location = "location",
  Expense = "expense",
  Tracker = "tracker",
  Rsvp = "rsvp",
}

export enum ModuleState {
  Planning = "planning",
  Done = "done",
  Locked = "locked",
  Archived = "archived",
}

export type PlaniraTemplateModule = {
  type: ModuleType;
  doneType: ModuleDoneType;
  completeAction?: ModuleCompleteInfo;
  title: string;
  isDraggable?: boolean;
  emoji: string;

  questionOption?: {
    question: string;
    questionDescription?: string;
    questionType: PlanQuestionType;
  };

  // For plan-info only right now
  descriptionYooptaEditor?: EditorValue | null;
  coverUrl?: string | null;
  backgroundColor?: string | null;

  // TODO fix types
  // biome-ignore lint/suspicious/noExplicitAny: Because
  settings?: any;

  defaultData?: ModuleDefaultData;

  keep?: boolean;
  onCreated?: (
    module: BaseModuleModel<Snapshot, ModuleModelData<Snapshot>>,
  ) => void;
};

export enum PlanQuestionType {
  None = "none",

  Dates = "dates",
  Location = "location",
}
